import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Select from 'react-select';

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: 'none',
    padding: '7px 9px',
    width: '225px'
  })
};

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 200,
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  select: {
    marginBottom: '.5rem'
  }
}));

export const currencyOptions = [
  { value: 'euros', label: 'Euros (€)', color: '#00B8D9' },
  { value: 'dollars', label: 'Dollars ($)', color: '#0052CC' },
  { value: 'pounds', label: 'Pounds (£)', color: '#5243AA' }
];

const OrderSent = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h1>
        Order Sent{' '}
        <span role="img" aria-label="check">
          ✅
        </span>{' '}
      </h1>
    </div>
  );
};

export default OrderSent;
